var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-reset-password-form',{attrs:{"text-title":_vm.$tc('page.reset_password.title'),"text-sub-title":_vm.$tc('page.reset_password.text'),"text-back-to-login-button":_vm.$tc('page.reset_password.to_login_page'),"text-token-not-valid":_vm.$tc('page.reset_password.token_not_valid')}})
}
var staticRenderFns = []

export { render, staticRenderFns }